import { render, staticRenderFns } from "./DbtSettting.vue?vue&type=template&id=6760636e&lang=html"
import script from "./DbtSettting.vue?vue&type=script&lang=js"
export * from "./DbtSettting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports